module.exports = __webpack_public_path__ + "b196d81ab5d9466598feae74d4b128be.svg";